import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import { app } from "./config";
import { db } from "./firestore";

const VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

let messaging = null;
try {
  messaging = getMessaging(app);
} catch {
  // Messaging not supported (e.g. Safari without push, or non-secure context)
}

/**
 * Request notification permission, get FCM token, and store it in Firestore.
 * Call this once per session after login.
 */
export async function registerForNotifications(userEmail) {
  if (!messaging || !VAPID_KEY) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const swReg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

  const token = await getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: swReg,
  });

  if (token) {
    // Store token in Firestore under the user's email
    await setDoc(
      doc(db, "fcmTokens", token),
      { email: userEmail, token, updatedAt: new Date().toISOString() },
      { merge: true },
    );
  }

  return token;
}

/**
 * Listen for foreground messages and show a browser notification.
 */
export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    const title = payload.data?.title || payload.notification?.title;
    const body = payload.data?.body || payload.notification?.body;
    if (title && Notification.permission === "granted") {
      new Notification(title, { body: body || "", icon: "/logo192.png", requireInteraction: true });
    }
    if (callback) callback(payload);
  });
}
